import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.pug',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent {
}



// WEBPACK FOOTER //
// ./src/app/layout/footer/footer.component.ts